<template>
  <div class="tlifiulcont">
    <div class="twotitle">{{ currenttitle }}法规</div>
    <div class="tag between">
      <div class="tagleft flex_start">
        <span
          v-for="(item, index) in tl"
          :key="index"
          :class="{ tlact: index == tlact }"
          @click="tlcli(index)"
          >{{ item.name }}</span
        >
      </div>
      <div class="tagright flex_end">
        <span :class="{ act: 0 == hotact }" @click="tlcli2(0)">最新</span>
        <span class="hot" :class="{ act: 1 == hotact }" @click="tlcli2(1)">
          热门
        </span>
      </div>
    </div>
    <div class="list">
      <div
        class="item"
        v-for="(item, index) in fglist"
        :key="index"
        @click="totilinfo(item)"
      >
        <div class="between">
          <div class="it1">
            {{ item.title }}
          </div>
          <div
            class="it2"
            :class="{
              it2_c1: item.timeliness == '现行有效',
              it2_c2: item.timeliness == '现已失效',
              it2_c3: item.timeliness == '尚未生效',
              it2_c4: item.timeliness == '已修订',
            }"
          >
            {{ item.timeliness }}
          </div>
        </div>
        <div class="itdes">
          {{ item.content | toEllipsisFilter(50) }}
        </div>
        <div class="flex_start item4">
          <div>颁布时间：{{ item.issue_date }}</div>
          <div>实施时间：{{ item.effect_date }}</div>
          <div>颁布单位：{{ item.issue_unit }}</div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        :current-page="currentPage"
        :pager-count="5"
        @current-change="turnpage"
        @prev-click="turnpage(--currentPage)"
        @next-click="turnpage(++currentPage)"
      >
      </el-pagination>
      <div class="textnum">[共{{ pageCount }}页]</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cat_id: String,
  },
  data: () => ({
    currenttitle: "婚姻家庭",
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
    tlact: 0,
    tl: [
      { name: "全部", id: "0" },
      { name: "现行有效", id: "1" },
      { name: "现已失效", id: "2" },
      { name: "尚未生效", id: "3" },
      { name: "已修订", id: "4" },
    ],
    hotact: 0,
    fglist: [],
  }),
  computed:{
    tiaolisea(){
      return this.$store.state.jpcol.tiaolisea
    }
  },
  beforeMount() {
    this.getfglist();
  },
  methods: {
    tlcli(index) {
      if (this.tlact == index) return;
      this.tlact = index;
      this.getfglist();
    },
    tlcli2(index) {
      if (this.hotact == index) return;
      this.hotact = index;
      this.getfglist();
    },
    turnpage(e) {
      this.currentPage = e;
      this.getfglist();
    },
    getfglist() {
      let data = {};
      console.log('getfglist');
      data = {
        page: this.currentPage,
        cat_id: this.cat_id,
        limit: 5,
        order: this.hotact ? "hot" : "new",
        timeliness: this.tlact,
      };
      data.timeliness == 0 ? delete data.timeliness : "";

      if (this.$route.query.search) {
        data = { ...this.tiaolisea };
        data.limit = 100
      }

      this.$http.jpcol.gettiaolilist(data).then((res) => {
        this.currenttitle = res.data.cat_name;
        this.pageCount = res.data.last_page;
        this.total = res.data.count;
        this.fglist = res.data.data;
      });
    },
    totilinfo(item) {
      this.$router.push({
        path: "/jpcol/tiaoli/tiaolidetail",
        query: {
          tlId: item.id,
        },
      });
    },
  },
  watch: {
    tiaolisea() {
      this.currentPage = 1;
      this.tlact = 0;
      this.getfglist();
    },
  },
};
</script>

<style lang="scss" scoped>
.tlifiulcont {
  background-color: #ffffff;
  .twotitle {
    font-size: 24px;
    color: #333333;
    padding: 21px 27px;
  }
  .tag {
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    .tagleft {
      color: #333333;
      align-items: flex-start;
      span {
        cursor: pointer;
        padding: 8px 21px;
        &.tlact {
          border-bottom: 2px solid #0465ea;
          color: #0465ea;
        }
      }
    }
    .tagright {
      align-items: flex-start;
      padding: 8px 21px;
      span {
        line-height: 18px;
        margin-left: 10px;
        padding-left: 10px;
        cursor: pointer;
        &.hot {
          border-left: 1px solid #666666;
        }
        &.act {
          color: #ea8b04;
        }
      }
    }
  }
  .list {
    padding: 6px 20px;
    .item {
      cursor: pointer;
      margin-top: 24px;
      background: #fafafa;
      overflow: hidden;
      padding: 28px 20px;
      .it1 {
        width: 680px;
        font-size: 20px;
        color: #333333;
        line-height: 20px;
      }
      .it2 {
        border-radius: 4px;
        position: relative;
        right: -24px;
        padding: 6px 11px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;

        &.it2_c1 {
          background-color: #3889f8;
        }
        &.it2_c2 {
          background-color: #ffb53b;
        }
        &.it2_c3 {
          background-color: #ababab;
        }
        &.it2_c4 {
          background-color: #7ed321;
        }
      }
      .itdes {
        font-size: 14px;
        color: #666666;
        margin-top: 16px;
      }
      .item4 {
        margin-top: 16px;
        font-size: 12px;
        color: #999999;
        div {
          margin-right: 30px;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    padding: 30px 0;

    .textnum {
      color: #333;
      margin-top: 15px;
    }
  }
}
</style>